import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getStudentInfo} from 'shared/college-profile/actions/student';
import CollegeProfile from '../components';

const mapStateToProps = ({collegeProfile, loading}) => ({
  collegeProfile,
  loading,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({getStudentInfo}, dispatch);

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  getStudentInfo: () => dispatchProps.getStudentInfo(stateProps.collegeProfile.userInfo.user),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CollegeProfile);
